import { render, staticRenderFns } from "./SaveIcon.vue?vue&type=template&id=0e7102ce"
import script from "./SaveIcon.vue?vue&type=script&lang=ts"
export * from "./SaveIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports